module.exports = __webpack_public_path__ + "static/media/Project1_Cover.c3b977a7.png";